module.exports = __webpack_public_path__ + "img/BT.beff6914.svg";